/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-badge[_ngcontent-%COMP%]{right:30px!important;top:25px!important}"];
export { styles as styles };
